<div role="document">
  <div>
    <h2 id="prep-file-heading">Modifier Notification</h2>
  </div>

  <div class=" justify-content-center">
    <form name="editForm" role="form" novalidate (ngSubmit)="f.form.valid && save()" [formGroup]="employeesCreateForm"
      #f="ngForm">
        <fieldset class="border p-2">
          <legend class="w-auto">Paramètre</legend>
          <div class="form-group row">
            <label for="type" class="col-1 col-form-label">Type</label>
            <div class="col-3">
              <select class="custom-select" formControlName="type" (change)="refreshDestinataire()" >
                <option *ngFor=" let typeCnt of typeContrat" [ngValue]="typeCnt.code">
                  {{typeCnt.name}}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group row mb-2">
                <ng-container *ngIf="employeesCreateForm?.controls?.type?.value === 'MAIL'">
                  <label  class="col-1 col-form-label" for="destValue">Email </label>
                  <div class="col-3">
                    <input type="email" class="form-control" id="destValue"
                        name="destValue" [ngClass]="{ 'forminput-invalid':
                      f.submitted && employeesCreateForm?.controls?.destValue?.errors != null}" formControlName="destValue"  />
                      <div *ngIf="f.submitted && employeesCreateForm?.controls?.destValue?.errors?.email" class="text-danger">
                        format Email non valide
                      </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="employeesCreateForm?.controls?.type?.value === 'TEL' ||  employeesCreateForm?.controls?.type?.value ==='SMS' ">
                  <label  class="col-1 col-form-label" for="destValue">Telephone</label>
                  <div class="col-3">
                    <input type="text" class="form-control" id="destValue"
                    name="destValue" [ngClass]="{ 'forminput-invalid':
                    f.submitted && employeesCreateForm?.controls?.destValue?.errors != null}" formControlName="destValue"  />

                  </div>
                </ng-container>
          </div>

          <div class="form-group row">
            <label for="type" class="col-1 col-form-label">Evènement</label>
            <div class="col-3">
              <select class="custom-select" formControlName="eventType" >
                <option *ngFor=" let typeCnt of typeEvent" [ngValue]="typeCnt.code">
                  {{typeCnt.name}}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label  class="col-3 col-form-label" for="waitBeforeSendMin">Temps d'attente (Min)</label>
            <div class="col-1">
              <input type="number" class="form-control" id="waitBeforeSendMin"
              name="waitBeforeSendMin" [ngClass]="{ 'forminput-invalid':
              f.submitted && employeesCreateForm?.controls?.waitBeforeSendMin?.errors != null}" formControlName="waitBeforeSendMin"  />
              <div *ngIf="f.submitted && employeesCreateForm?.controls?.waitBeforeSendMin?.errors?.required" class="text-danger">
                champ Obligatoire
              </div>
            </div>
          </div>
        </fieldset>
          <fieldset class="border p-2">
            <legend class="w-auto">Cible</legend>

            <div class="form-group row align-items-center">
              <label class="form-control-label col-auto" for="target"><br/>Niveau de notification</label>
              <div class="col d-flex  flex-row">
                <div class="form-check">
                  <input class="form-check-input" (change)="refreshTarget()"
                  type="radio"  value= "ZONE"
                  formControlName="target">
                  <label class="form-check-label" >
                    Zone
                  </label>
                </div>
                <div class="ml-2 form-check">
                  <input class="form-check-input" (change)="refreshTarget()"
                  type="radio"  value = "PLACE"
                  formControlName="target">
                  <label class="form-check-label" >
                    Place
                  </label>
                </div>
                <div class="ml-2 form-check">
                  <input class="form-check-input" (change)="refreshTarget()"
                  type="radio"  value = "TYPE_PLACE"
                  formControlName="target">
                  <label class="form-check-label" >
                    Type de Place
                  </label>
                </div>
                <div *ngIf="f.submitted && employeesCreateForm?.controls?.target?.errors"
                  class="text-danger">
                    champ Obligatoire
                  </div>
            </div>
           </div>
        <ng-container *ngIf="employeesCreateForm.controls?.target?.value == 'PLACE'">
          <div class="form-group row">

            <label  class="col-1 col-form-label" for="reference">Places</label>
            <div class="col-3">
              <ng-select  name="targetIds" dropdownPosition='bottom'
                formControlName="targetIds" required
                [ngClass] = "{ 'forminput-invalid':f.submitted &&
                employeesCreateForm['controls']?.targetIds?.errors != null}"
                  [items]="places" [multiple]="true" [bindLabel]="'label'"
                  [closeOnSelect]="false" bindValue="id" style="padding-left: 0px;
                            padding-right: 0px;">
                </ng-select>
                <div *ngIf="f.submitted && employeesCreateForm?.controls?.targetIds?.errors"
                class="text-danger">
                  champ Obligatoire
                </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="employeesCreateForm.controls?.target?.value == 'ZONE'">
          <div class="form-group row">
            <label  class="col-1 col-form-label" for="reference">Zones</label>
            <div class="col-3">
              <ng-select  name="targetIds" dropdownPosition='bottom'
                formControlName="targetIds" required
                [ngClass] = "{ 'forminput-invalid':f.submitted &&
                employeesCreateForm['controls']?.targetIds?.errors != null}"
                  [items]="zones" [multiple]="true" [bindLabel]="'label'"
                  [closeOnSelect]="false" bindValue="id" style="padding-left: 0px;
                            padding-right: 0px;">
                </ng-select>
                <div *ngIf="f.submitted && employeesCreateForm?.controls?.targetIds?.errors"
                class="text-danger">
                  champ Obligatoire
                </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="employeesCreateForm.controls?.target?.value == 'TYPE_PLACE'">
          <div class="form-group row">
            <label  class="col-1 col-form-label" for="reference">Type places</label>
            <div class="col-3">
                <ng-select class="mb-2"
              dropdownPosition='bottom' placeholder=""
                [items]="configurationTypes" [multiple]="true"
                [bindLabel]="'label'"
                [closeOnSelect]="false" bindValue="name" formControlName="targetIds"
                name="selectType">
              </ng-select>
                <div *ngIf="f.submitted && employeesCreateForm?.controls?.targetIds?.errors"
                class="text-danger">
                  champ Obligatoire
                </div>
            </div>
          </div>
        </ng-container>
      </fieldset>

      <div class="m-2">
        <button type="button" id="cancel-save" class="btn btn-secondary" data-dismiss="modal"
          [routerLink]="['/notifications']">
          &nbsp;<span>Annuler</span>
        </button>
        &nbsp;&nbsp;
        <button type="submit" id="save-entity" class="btn btn-indigo">
          <span>Valider</span>
        </button>
      </div>
    </form>
  </div>
</div>
